/**
 * O DOWNLOAD DO APLICATIVO "PORTAL SIMULADOS" PARA COMPUTADOR (etapa 6, 16/10/2026).
 *
 * Os links são FIXOS e levam sempre à versão mais nova publicada (`backend/src/routes/aplicativoRoutes.ts`,
 * `/api/aplicativo/baixar/…`): o mesmo endereço serve hoje e depois da próxima versão.
 *
 * O Mac tem dois arquivos (chip Apple e Intel), e o servidor não vê o processador — o Safari diz "Intel" também no chip
 * Apple. Quem estima é `qualComputador`, pelo nome da placa de vídeo que o navegador informa ("Apple M…" ou
 * "Intel/AMD"); sem saber, vale o chip Apple (os Macs vendidos desde 2020), com o Intel logo abaixo na tela.
 */
import { getApiBase } from '@/config';

export type Plataforma = 'windows' | 'mac' | 'mac-intel';

export const urlDeDownload = (p: Plataforma): string => `${getApiBase()}/api/aplicativo/baixar/${p}`;

export type Computador = { tipo: 'windows' } | { tipo: 'mac'; chip: 'apple' | 'intel' | null } | { tipo: 'celular' } | { tipo: 'outro' };

/** Que computador abriu a página. Sem certeza, a tela oferece as duas opções. */
export function qualComputador(nav: Navigator = navigator): Computador {
  const ua = nav.userAgent || '';
  const plataforma = ((nav as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform || nav.platform || '').toLowerCase();
  // iPad com iPadOS diz "Macintosh" no user agent; o toque denuncia.
  const toque = (nav.maxTouchPoints ?? 0) > 1;
  if (/android|iphone|ipod|ipad/i.test(ua) || (/macintosh/i.test(ua) && toque)) return { tipo: 'celular' };
  if (plataforma.startsWith('win') || /windows nt/i.test(ua)) return { tipo: 'windows' };
  if (plataforma.startsWith('mac') || /macintosh|mac os x/i.test(ua)) return { tipo: 'mac', chip: chipDoMac() };
  return { tipo: 'outro' };
}

/** O chip do Mac pelo nome da placa de vídeo (WebGL). Nulo quando o navegador não diz. */
function chipDoMac(): 'apple' | 'intel' | null {
  try {
    const gl = document.createElement('canvas').getContext('webgl') as WebGLRenderingContext | null;
    if (!gl) return null;
    const info = gl.getExtension('WEBGL_debug_renderer_info');
    const nome = String(info ? gl.getParameter(info.UNMASKED_RENDERER_WEBGL) : gl.getParameter(gl.RENDERER)) || '';
    if (/apple m\d|apple gpu/i.test(nome)) return /apple gpu/i.test(nome) ? null : 'apple';
    if (/intel|amd|radeon|nvidia/i.test(nome)) return 'intel';
    return null;
  } catch {
    return null;
  }
}
